import React from 'react';
import star_one from '../../asset/star_one.png';
import star_half from '../../asset/star_half.png';
import star_none from '../../asset/star_none.png';

const ScoreNum = (score) => {
    const score_num = [];
    var score_i = Number(score);
    for (var i = 0; i < 5; ++i) {
        if (score_i <= 0) {
            score_num.push('none');
        } else if (score_i < 1) {
            score_num.push('half');
        } else {
            score_num.push('one');
        }
        score_i -= 1;
    }
    return score_num
}

const StarList = (star) =>{
    if(star['star']==='none'){
        return <img src={star_none} alt='' style={{width:'13px',height:'13px'}}/>
    }else if(star['star']==='one'){
        return <img src={star_one} alt='' style={{width:'13px',height:'13px'}}/>
    }else{
        return <img src={star_half} alt='' style={{width:'13px',height:'13px'}}/>
    }
}

export default class ScoreStar extends React.Component {
    render() {
        return(
            ScoreNum(this.props.score).map((item,idx)=> <StarList key={idx} star={item} />)
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/star/index.js